import type { TransportationGroupsListResponse } from './api';

export const normalizeTransportationGroupsList = (
  list: TransportationGroupsListResponse,
): { label: string; value: string }[] => {
  if (!list) {
    return [];
  }
  return list.map((row) => ({
    label: row.codeDesc,
    value: row.codeId,
  }));
};
